import { asLink, isFilled, RichTextField } from '@prismicio/client';
import {
  BannerStripSlice,
  BannerStripVariant,
} from '@adapters/prismic/types/brandedStorePage';
import { BANNER_STRIP_DEFAULT_ICONS } from '_components/BannerStrip/defaultIcons';

export interface BannerStripData {
  iconName: string;
  title?: RichTextField;
  subtitle?: RichTextField;
  cta?: { text: string; url: string };
  variant: BannerStripVariant;
}

const toIconName = (
  primary: BannerStripSlice['primary'],
  variant: BannerStripVariant
): string => {
  const isPhosphor = primary.icon_type === 'phosphor';
  const name = (isPhosphor ? primary.phosphor_icon : primary.icon_name)?.trim();
  if (!name) return BANNER_STRIP_DEFAULT_ICONS[variant];
  if (isPhosphor && primary.phosphor_weight) {
    return `${name}-${primary.phosphor_weight}`;
  }
  return name;
};

const mapBannerStripData = (
  primary: BannerStripSlice['primary'] | null | undefined
): BannerStripData | null => {
  if (!primary) return null;

  const title = isFilled.richText(primary.title) ? primary.title : undefined;
  const subtitle = isFilled.richText(primary.subtitle)
    ? primary.subtitle
    : undefined;
  if (!title && !subtitle) return null;

  const variant: BannerStripVariant =
    primary.variant === 'light' ? 'light' : 'membership';

  const ctaText = primary.cta_text?.trim();
  const ctaUrl = primary.cta_url ? asLink(primary.cta_url) : null;

  return {
    iconName: toIconName(primary, variant),
    ...(title ? { title } : {}),
    ...(subtitle ? { subtitle } : {}),
    ...(ctaText && ctaUrl ? { cta: { text: ctaText, url: ctaUrl } } : {}),
    variant,
  };
};

export default mapBannerStripData;
